export const fetchApi = (url, options = {}) => {
  const defaultHeaders = options.raw
    ? {
        "x-access-token": localStorage.getItem("access_token"),
      }
    : {
        "Content-Type": "application/json",
        "x-access-token": localStorage.getItem("access_token"),
      };

  return fetch(
    `${process.env.REACT_APP_API_ENDPOINT}${url}`,
    Object.assign({}, options, {
      headers: Object.assign({}, defaultHeaders, options.headers),
    })
  )
    .then((response) => {
      const responseType = response.headers.get("Content-Type");

      if (responseType.indexOf("application/json") > -1) {
        return response.json().then((json) => ({ json, response }));
      } else {
        return response.text().then((text) => ({ text, response }));
      }
    })
    .then(({ json, text, response }) => {
      if (!response.ok) {
        if (response.status === 401) {
          return (window.location = `${process.env.REACT_APP_API_ENDPOINT}/access/logout`);
        }
        return Promise.reject({
          status: response.status,
          body: json || text,
        });
      }
      return { json, text, response };
    });
};

export const postApi = (url, postData, options = {}) => {
  const isFormData =
    postData && postData.constructor && postData.constructor.name == "FormData";
  const body = isFormData ? postData : JSON.stringify(postData);

  return fetchApi(
    url,
    Object.assign({}, options, {
      method: "post",
      body,
      raw: isFormData,
    })
  );
};

export const putApi = (url, postData, options = {}) => {
  return fetchApi(
    url,
    Object.assign({}, options, {
      method: "put",
      body: JSON.stringify(postData),
    })
  );
};

export const deleteApi = (url, postData, options = {}) => {
  return fetchApi(
    url,
    Object.assign({}, options, {
      method: "delete",
      body: JSON.stringify(postData),
    })
  );
};

export const dispatchApiCall = (
  dispatch,
  promise,
  actions,
  additionalData = {}
) => {
  if (actions.request) {
    dispatch(
      Object.assign(
        {},
        additionalData,
        {
          type: actions.request,
          list: actions.list,
          subList: actions.subList,
          fetching: true,
        },
        actions.reset
          ? {
              reset: true,
            }
          : undefined
      )
    );
  }
  return promise
    .then(({ json, text, response }) => {
      if (actions.success) {
        var result = Object.assign({}, additionalData, actions, {
          type: actions.success,
          data: json || text,
        });

        const nextPageUrl = getNextPageUrl(response);
        if (nextPageUrl) {
          result.nextPageUrl = nextPageUrl;
        }
        dispatch(result);
        return result;
      }
    })
    .catch((err) => {
      if (actions.failure && !!dispatch) {
        dispatch({ type: actions.failure, error: err });
      }
    });
};

export const pluckJson = (obj) => obj.json;

export const serializeQueryString = function (obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};

// Extracts the next page URL from API response.
export const getNextPageUrl = (response) => {
  const link = response.headers.get("link");
  if (!link) {
    return null;
  }

  const nextLink = link.split(",").find((s) => s.indexOf('rel="next"') > -1);
  if (!nextLink) {
    return null;
  }

  return nextLink.split(";")[0].slice(1, -1);
};
